import { useState, useEffect } from 'react';

import { Typography } from '@mui/material';
import { useAuth } from 'contexts/auth';
import {
  Container,
  AppHeader,
  AppLogo,
  CardLogin,
  LoginLogo,
  LoginCardHeader,
  LoginCardBody,
  LoginCardFooter,
} from 'styles/Styles';
import { getBackgroundImage, getLogo, getSlugFromURL } from 'utils/whiteLabel';

export default function NotFound(props: any) {
  const context = useAuth();
  const PROJECT = getSlugFromURL();

  const [time, setTime] = useState(10);

  const startTime = () => {
    setInterval(function () {
      setTime(time - 1);
    }, 1000);
  };

  startTime();

  const goToHome = () => {
    window.location.hash = ''; // este código é importante para que funcione no desktop
  };

  useEffect(() => {
    if (time === 0) {
      goToHome();
    }
  }, [time]);

  return (
    <Container
      style={{ backgroundImage: `url(${getBackgroundImage(context.selectedProject ?? PROJECT)})` }}
    >
      <AppHeader>
        <CardLogin>
          <LoginLogo>
            <AppLogo src={getLogo(context.selectedProject ?? PROJECT)} height="135" alt="logo" />
          </LoginLogo>
          <LoginCardHeader style={{ backgroundColor: props.headerColor ?? '#000080' }}>
            Página não encontrada
          </LoginCardHeader>
          <LoginCardBody>
            <Typography variant="h6" color="textPrimary">
              {'A página que você tentou acessar não existe, será redirecionado para a tela inicial em ' +
                time +
                ' segundos.'}
            </Typography>
          </LoginCardBody>
          <LoginCardFooter>
            <div className="d-flex justify-content-center">
              <Typography variant="caption" color="textSecondary">
                Para ir para a tela inicial agora
                <a href="/#" onClick={goToHome}>
                  <Typography variant="caption"> clique aqui</Typography>
                </a>
              </Typography>
            </div>
          </LoginCardFooter>
        </CardLogin>
      </AppHeader>
    </Container>
  );
}
